<script>
  import IconLabel from "../molecules/IconLabel.vue";

  export default {
    name: "SidebarHeader",
    components: { IconLabel },
    props: {
      icon: { type: String, default: "historyIcon" },
      title: { type: String, required: true },
    },
  };
</script>

<template>
  <div class="SidebarHeader">
    <IconLabel :icon="icon" :title="title" text="" variant="red" class="SidebarHeader__iconLabel" />
    <button class="SidebarHeader__close" @click="$emit('close')">
      <iconic name="xIcon" />
    </button>
  </div>
</template>

<style lang="scss">
  .SidebarHeader {
    @include Flex(row, space-between, center);
    width: 100%;
    margin-bottom: $space-12;

    &__iconLabel {
      .IconLabel__textBold {
        font-family: $newFont_semiBold;
        align-items: flex-start;
      }
      .IconLabel__icon {
        margin-top: 4px;
      }
    }
    &__close {
      background: none;
      border: none;
      @include Flex();
      cursor: pointer;
      color: #4c4c4c;
      font-size: 14px;
    }
  }
</style>
